import * as React from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import DirectionsIcon from "@mui/icons-material/Directions";

export default function SearchBar() {
  return (
    <Paper
      component="form"
      sx={{
        p: "2px 4px",
        display: "flex",
        alignItems: "center",
        width: 400,
        direction: "rtl",
        height: 40,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1, fontFamily: "font" }}
        placeholder="بحث"
        inputProps={{ "aria-label": "بحث" }}
        size="small"
      />
      <IconButton
        size="small"
        type="button"
        sx={{ p: "10px" }}
        aria-label="search"
      >
        <SearchIcon />
      </IconButton>
    </Paper>
  );
}
